export default __webpack_public_path__ + "static/ccl-2-352118198d458e9ef48bc37740193a5e.png";